import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import HostedPage from './components/hosted-page'
import { getSentryEnvKey } from './config/config'
import SdkPage from './components/sdk-page/SdkPageWithTimeout'
import packageJson from '../package.json'
import * as Sentry from '@sentry/react'

import './assets/main.css'
import './index.scss'
import './App.css'
import Receipt from './components/receipt'

const baseUri = window.env.REACT_APP_DEMO_BASE_URI

// Get version from package.json
const version = process.env.REACT_APP_VERSION || packageJson.version
console.info('sdk-hpp-fe v' + version)

const router = createBrowserRouter(
    [
        {
            path: '/sdk/:id',
            element: <SdkPage />,
        },
        {
            path: '/',
            element: <HostedPage />,
        },
        {
            path: '/:data',
            element: <HostedPage />,
        },
        {
            path: '/payment/receipt',
            element: <Receipt />,
        },
    ],
    {
        basename: baseUri,
        future: {
            v7_startTransition: true,
        },
    },
)

// Track if Sentry has been initialized to prevent duplicate initialization
let sentryInitialized = false

// Lazy load Sentry to reduce initial bundle size
const initializeSentry = async () => {
    // Prevent multiple Sentry initializations
    if (sentryInitialized) {
        console.debug('Sentry already initialized, skipping re-initialization')
        return
    }

    try {
        Sentry.init({
            environment: getSentryEnvKey(),
            dsn: import.meta.env.VITE_SENTRY_DSN,
            release: import.meta.env.VITE_SENTRY_RELEASE,
            integrations: [
                Sentry.browserTracingIntegration({
                    tracePropagationTargets: [
                        /^http?:\/\/[a-z0-9-]+\.localhost/,
                        /^https?:\/\/[a-z0-9-]+\.ecomm\.dmginternal\.net/,
                        /^https?:\/\/[a-z0-9-]+\.ecomm\.dmgnet\.io/,
                    ],
                }),
                Sentry.replayIntegration({
                    maskAllText: true,
                    blockAllMedia: false,
                }),
            ],
            tracesSampleRate: 0.25,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        })

        console.debug('Sentry initialized successfully')
    } catch (error) {
        console.error('Failed to initialize Sentry:', error)
    }
}

// Initialize Sentry after a short delay to prioritize initial app rendering
setTimeout(initializeSentry, 100)

ReactDOM.createRoot(document.getElementById('root')).render(<RouterProvider router={router} />)
